import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { graphql, compose } from "react-apollo";
import meQuery from "utils/queries/MeQuery";
import updateUserMutation from "utils/mutations/UpdateUser";
import { UNIT_SYSTEMS } from "scenes/ProductDetails/components/ProductSpecs/components/ChangeUnitSystemLink/components/ChangeUnitSystemModal/constants/unit_systems";
import { apolloClient } from 'apollo/client';
import { singlePatternPrivatePDFQuery, singlePatternPublicPDFQuery } from 'scenes/ProductDetails/components/DownloadPatternPDFButton/queries';
import PDFsContext from 'scenes/ProductDetails/components/ProductSpecs/contexts/PDFsContext';
import PatternContext from 'scenes/ProductDetails/components/ProductSpecs/contexts/PatternContext';

function ChangeUnitSystemModal(props) {
  const { isOpen, toggle, meQuery, updateUserMutation } = props;
  const { me } = meQuery;

  const { setPdfsLoading } = useContext(PDFsContext);
  const pattern = useContext(PatternContext);
  const [selectedUnitSystem, setSelectedUnitSystem] = useState(me?.unitSystem || null);

  const handleSelectChange = (event) => {
    setSelectedUnitSystem(event.target.value);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    await updateUserMutation({
      variables: {
        input: {
          userId: me.id,
          unitSystem: selectedUnitSystem,
        },
      },
      refetchQueries: [
        'SinglePatternGeneralQuery',
        'SinglePatternBackingQuery',
        'MultiplePatternsQuery',
        'SinglePatternPDFQuery'
      ],
    });

    toggle();

    try {
      setPdfsLoading(true);

      // Refetch PDFs
      await Promise.all([
        apolloClient.query({
          query: singlePatternPublicPDFQuery,
          variables: { id: pattern?.id },
          fetchPolicy: "network-only",
        }),
        apolloClient.query({
          query: singlePatternPrivatePDFQuery,
          variables: { id: pattern?.id },
          fetchPolicy: "network-only",
        }),
      ]);

      setPdfsLoading(false);
    } catch (error) {
      console.error("Failed to fetch PDFs after changing unit system", error);
    }
  };

  if (!me) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <FormattedMessage
          id="ChangeUnitSystemModal.title"
          description="Title of Change unit system modal"
          defaultMessage="Change Unit System"
        />
      </ModalHeader>

      <form onSubmit={handleFormSubmit}>
        <ModalBody>
          <div className="form-group">
            <select
              className="form-control"
              name="unitSystem"
              value={selectedUnitSystem}
              onChange={handleSelectChange}
            >
              {UNIT_SYSTEMS.map((unitSystem, index) => (
                <option key={index} value={unitSystem.value}>
                  {unitSystem.display}
                </option>
              ))}
            </select>
          </div>
        </ModalBody>

        <ModalFooter>
          <button type="submit" className="btn btn-primary">
            <FormattedMessage
              id="ChangeUnitSystemModal.saveButton"
              description="save button label of Change unit system modal"
              defaultMessage="Save"
            />
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
}

ChangeUnitSystemModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default compose(
  graphql(meQuery, { name: "meQuery" }),
  graphql(updateUserMutation, { name: "updateUserMutation" })
)(ChangeUnitSystemModal);
